import React from 'react';

const Loader = ({ fullScreen = false }) => {
  if (fullScreen) {
    return (
      <div className="loader-fullscreen">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <div className="loader">
      <div className="spinner"></div>
    </div>
  );
};

export default Loader;